export const MEMBER_HEADER_CONTROL_SIZE = 56;
export const MEMBER_HEADER_ACCOUNT_MIN_WIDTH = 128;
export const MEMBER_HEADER_CONTROL_GAP = 16;
export const MEMBER_PROFILE_ACTION_EDGE_INSET = 16;
